/* =====================================================
   QUICK ADD
===================================================== */

document.addEventListener('submit', async (event) => {

  const form = event.target.closest('[data-quick-add]');

  if (!form) return;

  event.preventDefault();

  const button = form.querySelector(
    '[data-quick-add-button]'
  );

  if (!button) return;

  button.classList.add('is-loading');
  button.disabled = true;

  try {

    const formData = new FormData(form);

    await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    document.dispatchEvent(
      new CustomEvent('digi:cart:refresh')
    );

    document.dispatchEvent(
      new CustomEvent('cart:drawer:open')
    );

  } catch(error) {

    console.error(error);

  } finally {

    button.classList.remove('is-loading');
    button.disabled = false;

  }

});

/* =====================================================
   PRICE RANGE
===================================================== */

function digiFormatPriceRangeValue(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL',
    maximumFractionDigits: 0
  }).format(Number(value) || 0);
}

function digiSyncPriceRange(group, changedInput) {
  if (!group) return;

  const minInput = group.querySelector('[data-price-min]');
  const maxInput = group.querySelector('[data-price-max]');
  const minOutput = group.querySelector('[data-price-min-output]');
  const maxOutput = group.querySelector('[data-price-max-output]');

  if (!minInput || !maxInput) return;

  let minValue = Number(minInput.value);
  let maxValue = Number(maxInput.value);
  const rangeMin = Number(minInput.min) || 0;
  const rangeMax = Number(maxInput.max) || 1;
  const rangeSpread = Math.max(rangeMax - rangeMin, 1);

  if (minValue > maxValue) {
    if (changedInput === minInput) {
      minValue = maxValue;
      minInput.value = String(minValue);
    } else {
      maxValue = minValue;
      maxInput.value = String(maxValue);
    }
  }

  const rangeStart = (minValue - rangeMin) / rangeSpread * 100;
  const rangeEnd = (maxValue - rangeMin) / rangeSpread * 100;

  group.style.setProperty('--range-start', rangeStart + '%');
  group.style.setProperty('--range-end', rangeEnd + '%');

  const histogramBars = group.querySelectorAll(
    '.digi-search-filters__histogram span'
  );

  histogramBars.forEach((bar, index) => {
    const barPosition = (index + 0.5) / histogramBars.length * 100;
    const isInsideRange =
      barPosition >= rangeStart &&
      barPosition <= rangeEnd;

    bar.classList.toggle('is-active', isInsideRange);
  });

  if (minOutput) {
    minOutput.textContent = digiFormatPriceRangeValue(minValue);
  }

  if (maxOutput) {
    maxOutput.textContent =
      digiFormatPriceRangeValue(maxValue) +
      (maxValue >= rangeMax ? '+' : '');
  }
}

function digiInitPriceRanges(root) {
  (root || document).querySelectorAll('[data-digi-price-range]').forEach((group) => {
    digiSyncPriceRange(group);

    group.querySelectorAll('.digi-search-filters__range-input').forEach((input) => {
      input.addEventListener('input', () => {
        digiSyncPriceRange(group, input);
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  digiInitPriceRanges(document);
});

/* =====================================================
   SEARCH AJAX FILTER
===================================================== */

document.addEventListener('change', async (event) => {

  const target = event.target;

  if (!target.matches('.digi-search-filters__checkbox, .digi-search-filters__range-input')) return;

  const form = target.closest(
    '[data-digi-filters-form]'
  );

  if (!form) return;

  const params = new URLSearchParams(
    new FormData(form)
  );

  const url =
    `${form.action}?${params.toString()}`;

  try {

    const response =
      await fetch(url);

    const html =
      await response.text();

    const parser =
      new DOMParser();

    const documentHTML =
      parser.parseFromString(
        html,
        'text/html'
      );

    const newList =
      documentHTML.querySelector(
        '[data-search-list]'
      );

    const currentList =
      document.querySelector(
        '[data-search-list]'
      );

    if (
      newList &&
      currentList
    ) {

      currentList.innerHTML =
        newList.innerHTML;

    }

    const newHeader =
      documentHTML.querySelector(
        '[data-search-header]'
      );

    const currentHeader =
      document.querySelector(
        '[data-search-header]'
      );

    if (
      newHeader &&
      currentHeader
    ) {

      currentHeader.innerHTML =
        newHeader.innerHTML;

    }

    const newCount =
      documentHTML.querySelector(
        '[data-search-count]'
      );

    const currentCount =
      document.querySelector(
        '[data-search-count]'
      );

    if (
      newCount &&
      currentCount
    ) {

      currentCount.innerHTML =
        newCount.innerHTML;

    }

    window.history.replaceState(
      {},
      '',
      url
    );

  } catch(error) {

    console.error(error);

  }

});

/* =====================================================
   MOBILE FILTER DRAWER
===================================================== */

document.addEventListener('DOMContentLoaded', () => {

  const filters = document.querySelector(
    '.digi-search-filters'
  );

  const openButton = document.querySelector(
    '[data-digi-filters-open]'
  );

  const closeButtons = document.querySelectorAll(
    '[data-digi-filters-close]'
  );

  if (filters && openButton) {

    openButton.addEventListener('click', () => {

      filters.classList.add('is-open');

      document.body.style.overflow = 'hidden';

    });

  }

  closeButtons.forEach(button => {

    button.addEventListener('click', () => {

      if (!filters) return;

      filters.classList.remove('is-open');

      document.body.style.overflow = '';

    });

  });

});